export function loadScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.onload = () => {
            resolve(true)
        }
        script.onerror = () => {
            resolve(false)
        }
        document.body.appendChild(script)
    })
}

export const encodeToBase64 = (input) => {
    try {
        return btoa(input);
    } catch (error) {
        console.error("Failed to encode to Base64:", error);
        return null;
    }
};

export function maskInput(input, maxLength = 15) {
    // Check if the input is a mobile number (contains only digits)
    if (/^\d+$/.test(input)) {
        // Mask mobile number: Keep the last 4 digits and prepend with asterisks
        const lastFourDigits = input.slice(-4);
        const maskedMobile = `****${lastFourDigits}`;
        return maskedMobile;
    } else {
        // Treat input as an email
        const [localPart, domainPart] = input.split("@");

        if (!domainPart) {
            throw new Error("Invalid email format");
        }

        // Mask local part: keep first 3 characters
        let visibleLocalStart = localPart.slice(0, 3);
        let maskedLocal = visibleLocalStart + "***";

        // Mask domain part: keep ".com" or other TLD
        const domainParts = domainPart.split(".");
        const maskedDomain = "***." + domainParts[domainParts.length - 1];

        // Combine masked parts
        let maskedEmail = `${maskedLocal}@${maskedDomain}`;

        // Trim to maxLength if necessary
        if (maskedEmail.length > maxLength) {
            maskedEmail = maskedEmail.slice(0, maxLength - 3) + "...";
        }

        return maskedEmail;
    }
}

export function formatToCurrency(number) {
    if (!number || isNaN(number)) return 0;
    return Number(number).toLocaleString('en-IN');
}

export function formatIndianNumber(value) {
    if (value === undefined || value === null || value === "") return "";
    
    // Clean any existing commas or spaces first
    let str = value.toString().replace(/,/g, "").trim();
    
    // Split into integer and decimal parts
    const parts = str.split(".");
    let integerPart = parts[0];
    const decimalPart = parts.length > 1 ? "." + parts[1] : "";
    
    // Only format if we have digits in the integer part
    if (integerPart) {
        let lastThree = integerPart.substring(integerPart.length - 3);
        const otherNumbers = integerPart.substring(0, integerPart.length - 3);
        if (otherNumbers !== "") {
            lastThree = "," + lastThree;
        }
        const formattedInteger = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return formattedInteger + decimalPart;
    }
    
    return str;
}


// Create a debouncing utility
export const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      return new Promise((resolve) => {
        timer = setTimeout(() => resolve(func(...args)), delay);
      });
    };
  };
export function truncateFilename(filename, startLength=10, endLength=10) {
    const [name, extension] = filename.split(".");
    if (name.length <= startLength + endLength) {
        return filename; // No truncation needed
    }
    const start = name.slice(0, startLength);
    const end = name.slice(-endLength);
    return `${start}...${end}.${extension}`;
}
  
export function numberToWords(amount) {
    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
      "Seventeen", "Eighteen", "Nineteen"
    ];
  
    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];
  
    const scales = ["", "Thousand", "Million", "Billion"];
  
    if (amount === 0) return "Zero";
  
    function convertToWords(num) {
      if (num < 20) return ones[num];
      if (num < 100) {
        return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + ones[num % 10] : "");
      }
      if (num < 1000) {
        return ones[Math.floor(num / 100)] + " Hundred" + (num % 100 !== 0 ? " " + convertToWords(num % 100) : "");
      }
      for (let i = 0, unit = 1000; i < scales.length; i++, unit *= 1000) {
        if (num < unit * 1000) {
          return (
            convertToWords(Math.floor(num / unit)) +
            " " +
            scales[i] +
            (num % unit !== 0 ? " " + convertToWords(num % unit) : "")
          );
        }
      }
    }
  
    return convertToWords(amount);
}

export function removeNullValues(obj) {
  return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => value !== null)
  );
}